module.exports = __webpack_public_path__ + "static/media/g-3-a.41b84954.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-3-a.jpg
// module id = 1132
// module chunks = 33